import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import httpPlugin from "./plugins/http"

// Vuex Modules
import app from "./modules/app"

// Vuex ORM Models
import News from "./models/News"
import Webinar from "./models/Webinar"
import WebinarCategory from "./models/WebinarCategory"

Vue.use(Vuex)
VuexORM.use(httpPlugin)

// Create a new database instance.
const database = new VuexORM.Database()
const models = [News, Webinar, WebinarCategory]
models.forEach((model) => {
	database.register(model, {
		namespaced: true
	})
})

// Create Vuex Store and register database through Vuex ORM.
const store = new Vuex.Store({
	plugins: [VuexORM.install(database)],
	modules: {
		app
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js